import classnames from 'classnames'
import * as React from 'react'

import { List, useListState } from '../list'
import { Popover, PopoverProps } from '../popover'

export interface SelectListProps extends Omit<PopoverProps, 'onChange'> {
  /**
   * The index of selected item
   */
  selectedIndex?: number

  /**
   * Handler called when selected item in list changes
   */
  onChange: (item: number) => void
}

export function SelectList({
  selectedIndex,
  onChange,
  'aria-label': ariaLabel,
  children,
  ...props
}: React.PropsWithChildren<SelectListProps>) {
  const listState = useListState({ currentId: null })

  return (
    <Popover {...props} aria-label={ariaLabel} className={classnames(props?.className, 'overflow-y-auto')}>
      <List
        state={listState}
        selectedIndex={selectedIndex}
        className="grow p-1"
        onChange={onChange}
        aria-label={ariaLabel}
      >
        {children}
      </List>
    </Popover>
  )
}
